import React, { useState } from "react";
import { Button, Flex } from "components";
import { ELEMENTS_IDS } from "constants/ElementsIds";
import ConfirmMoveToFieldModal from "components/MyLivestock/Animals/AnimalBulkActions/ConfirmMoveToFieldModal";
import { AddSelectedAnimalsToGroup } from "components/MyLivestock";
import { LogActivityModal } from "animals/LogActivityModal";
import { MarkAsDeadModal } from "animals/MarkAsDeadModal";
import { AddSelectedAnimalsToTag } from "components/MyLivestock/Animals/AnimalBulkActions/AddSelectedAnimalsToTag";
import { RemoveSelectedAnimalsToTag } from "components/MyLivestock/Animals/AnimalBulkActions/RemoveSelectedAnimalsToTag";

interface Props {
  animalIds: Array<string>;
}

export const AnimalActions: React.FC<Props> = ({ animalIds = [] }) => {
  const [showMoveToFieldConfirmation, setVisibleMoveToFieldConfirmation] = useState(false);
  const [showMarkAsDeadModal, setShowMarkAsDeadModal] = useState(false);

  const handleMoveAnimalToFieldClick = (): void => setVisibleMoveToFieldConfirmation(true);
  const handleMoveAnimalToFieldClose = (): void => setVisibleMoveToFieldConfirmation(false);

  return (
    <Flex container containerJustifyContent="flex-end" xs="fill">
      <Flex item itemGutter>
        <AddSelectedAnimalsToGroup animalIds={animalIds} />
      </Flex>

      <Flex item>
        <Button
          caption="Move to location"
          id={ELEMENTS_IDS.ANIMALS_MOVE_TO_FIELD_BUTTON}
          onClick={handleMoveAnimalToFieldClick}
        />

        <ConfirmMoveToFieldModal
          animals={animalIds}
          onClose={handleMoveAnimalToFieldClose}
          showModal={showMoveToFieldConfirmation}
        />
      </Flex>

      <Flex item itemGutter>
        <AddSelectedAnimalsToTag animalIds={animalIds} />
      </Flex>
      <Flex item>
        <RemoveSelectedAnimalsToTag animalIds={animalIds} />
      </Flex>

      <Flex item itemGutter>
        <Button caption="Mark as dead" onClick={() => setShowMarkAsDeadModal(true)} />
        {showMarkAsDeadModal && (
          <MarkAsDeadModal
            onClose={() => setShowMarkAsDeadModal(false)}
            animalIds={animalIds}
            showModal={showMarkAsDeadModal}
          />
        )}
      </Flex>

      <Flex item>
        <LogActivityModal animalIds={animalIds} />
      </Flex>
    </Flex>
  );
};
